import { Field } from '#models/questionnaire';
import { useFieldStyles, useLeadField } from '#modules/LeadGeneration/hooks/field';
import { Box, MenuItem, TextField, Typography } from '@material-ui/core';
import * as React from 'react';

interface DropdownFieldProps {
  field: Field;
  handleChangeFields?: (id: string, value: any) => void;
}

export const DropdownField = ({ field, handleChangeFields }: DropdownFieldProps) => {
  const [formField, { error, touched }] = useLeadField(field);
  const { stylesLabel, textField, menuItem } = useFieldStyles();

  return (
    <React.Fragment>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='subtitle2' className={stylesLabel}>
          {field.title}
        </Typography>
      </Box>
      <TextField
        {...formField}
        error={Boolean(error && touched)}
        select
        fullWidth
        variant='outlined'
        className={`${textField} ${formField.value ? '' : 'placeHolder'}`}
        value={formField.value ? formField.value : 'none'}
        onChange={(e) => {
          formField.onChange(e);
          if (handleChangeFields) handleChangeFields(field.id as string, e.target.value);
        }}
        InputProps={{ className: 'lead-input swyft-input' }}
        SelectProps={{ classes: { select: 'lead-select' } }}
        size='small'
      >
        <MenuItem value='none' disabled className={`${menuItem} placeHolder`}>
          {field.placeholderText}
        </MenuItem>
        {(field.dropdownOptions || []).map((opt) => (
          <MenuItem key={opt.id} value={opt.id} className={menuItem}>
            {opt.title}
          </MenuItem>
        ))}
      </TextField>
      {error && touched && (
        <Typography variant='subtitle2' color='error'>
          {error}
        </Typography>
      )}
    </React.Fragment>
  );
};
